import React, { useEffect, useState } from "react";
import {
  adminListTranslations,
  adminUpsertTranslation,
  adminDeleteTranslation,
} from "../../lib/api";

const EMPTY_FORM = { key: "", en: "", te: "", hi: "", ta: "", kn: "", ml: "" };
const LANG_FIELDS = [
  { code: "en", label: "English", required: true },
  { code: "te", label: "Telugu", required: true },
  { code: "hi", label: "Hindi", required: false },
  { code: "ta", label: "Tamil", required: false },
  { code: "kn", label: "Kannada", required: false },
  { code: "ml", label: "Malayalam", required: false },
];

export default function Translations() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(EMPTY_FORM);
  const [busy, setBusy] = useState(false);

  const load = async () => setItems(await adminListTranslations());
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await adminUpsertTranslation(form);
      setForm(EMPTY_FORM);
      await load();
    } catch (err) {
      alert(err?.response?.data?.detail || "Save failed");
    } finally {
      setBusy(false);
    }
  };

  const remove = async (key) => {
    if (!window.confirm(`Delete key "${key}"?`)) return;
    await adminDeleteTranslation(key);
    await load();
  };

  const edit = (row) => setForm({ ...EMPTY_FORM, ...row });

  return (
    <div data-testid="admin-translations">
      <div className="admin-heading">Translations</div>
      <div className="admin-sub">Multilingual resources served to the public site. Keys are referenced from the frontend by name. Hindi/Tamil/Kannada/Malayalam are optional — if left blank, the site falls back to English for that key.</div>

      <div className="admin-card" style={{ marginBottom: 24 }}>
        <form onSubmit={save}>
          <div className="admin-row">
            <div className="admin-field">
              <label>Key</label>
              <input data-testid="tr-key" value={form.key} onChange={(e) => setForm({ ...form, key: e.target.value })} required />
            </div>
            {LANG_FIELDS.map(({ code, label, required }) => (
              <div className="admin-field" key={code}>
                <label>{label}</label>
                <input
                  data-testid={`tr-${code}`}
                  value={form[code]}
                  onChange={(e) => setForm({ ...form, [code]: e.target.value })}
                  required={required}
                />
              </div>
            ))}
          </div>
          <button className="admin-btn" data-testid="tr-save" type="submit" disabled={busy}>Upsert</button>
        </form>
      </div>

      <div className="admin-card">
        <table className="admin-table" data-testid="tr-table">
          <thead>
            <tr>
              <th>Key</th>
              {LANG_FIELDS.map(({ code, label }) => <th key={code}>{label}</th>)}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map((row) => (
              <tr key={row.key}>
                <td><code>{row.key}</code></td>
                {LANG_FIELDS.map(({ code }) => <td key={code}>{row[code]}</td>)}
                <td className="actions">
                  <button className="admin-btn secondary" onClick={() => edit(row)}>Edit</button>
                  <button className="admin-btn danger" onClick={() => remove(row.key)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
